import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'

import { useError, useForm } from '../../hooks'
import { useFirebaseCRUD } from '../../hooks/useFirebaseCRUD'

import TextField from '../Form/TextField'
import Button from '../Button'
import Columns from '../Columns'
import ContextMenu from '../ContextMenu'
import Spinner from '../Spinner'

export default function ({ organizationId }) {
  const navigate = useNavigate()
  const setError = useError()

  const { getDocument, createDocument, loading, error } = useFirebaseCRUD()
  const [organization, setOrganization] = useState(null)

  const [getFieldProps, formData, formError] = useForm()

  // ✅ Fetch organization details (replacing useApiRequest)
  useEffect(() => {
    async function fetchOrg() {
      const orgData = await getDocument(`organizations/${organizationId}`)
      setOrganization(orgData)
    }
    fetchOrg()
  }, [organizationId])

  if (!organization) {
    return <Spinner />
  }

  async function handleSubmit(e) {
    e.preventDefault()

    let { name } = formData

    try {
      const newRoleId = `${Date.now()}` // ✅ custom ID to mimic backend response

      const success = await createDocument(
        `organizations/${organizationId}/user-roles/${newRoleId}`,
        {
          name,
          id:newRoleId,
          createdAt: new Date().toISOString()
        }
      )

      if (success) {
        navigate(`/user-roles/${newRoleId}?organizationId=${organizationId}`)
      } else {
        throw new Error('Failed to create user role')
      }
    } catch (err) {
      if (err.message === 'validation_error') {
        formError(err.props)
      } else {
        setError(err)
      }
    }
  }

  return (
    <div className='box'>
      <form onSubmit={handleSubmit}>
        <Columns>
          <TextField label='Organization' value={organization.name} readOnly={true} />
          <TextField
            label='Role name'
            name='name'
            type='Name'
            placeholder='Name'
            required={true}
            {...getFieldProps()}
          />
        </Columns>
        <div className='flex justify-end'>
          <Button type='submit' disabled={loading}>
            {loading ? 'Creating...' : 'Create'}
          </Button>
        </div>
        {error && <p style={{ color: 'red' }}>{error.message}</p>}
      </form>
    </div>
  )
}





// http://localhost:3000/user-roles/create?organizationId=3
// http://localhost:3000/user-roles/1752830917231?organizationId=3